import { render, staticRenderFns } from "./show-data.vue?vue&type=template&id=464520b9&scoped=true&"
import script from "./show-data.vue?vue&type=script&lang=js&"
export * from "./show-data.vue?vue&type=script&lang=js&"
import style0 from "./show-data.vue?vue&type=style&index=0&id=464520b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464520b9",
  null
  
)

export default component.exports